import axios from 'axios'

const fetchPaymentInformation = async (data) => {
  try {
    let res = await axios({
      method: 'post',
      url: `${process.env.VUE_APP_API_URL}/request/show`,
      data
    })
    return res;
  } catch (error) {
    return error;
  }
}

const requestCardPayment = async (params) => { 
  let ip = await axios({
    method: 'get',
    url: 'https://www.cloudflare.com/cdn-cgi/trace'
  })

  let ipConfigArray = ip.data.split('\n');
  let ipConfig = {}
  for(let config of ipConfigArray) {
    let configs = config.split('=');

    ipConfig[configs.shift()] = configs.pop();
  }

  let data = {
    amount: params.amount,
    api_key: params.api_key,
    buyer_name: '',
    buyer_email: params.email || '',
    buyer_phone_no: '',
    order_no: params.order_no,
    token: params.token,
    product_name: params.title,
    card_no: params.card.number,
    card_ymd: params.card.validity,
    quota: params.card.installmentMonths || '00',
    pay_kind: params.pay_kind,
    pay_method: params.pay_method,
    pg_code: params.pg_code,
    pg_kind: params.pg_kind,
    millis: new Date().getTime()+'',
    terminnal_no: '',
    ip_addr: ipConfig.ip,
    payload: {
      error_url: 'www.naver.com',
      success_url: 'www.google.com'
    }
  }
  console.log("payment data", data)
  
  try {
    let res = await axios({
      method: 'post',
      url: `${process.env.VUE_APP_API_URL}/card/approval`,
      headers: {
        "Access-Control-Allow-Origin": "*"
      },
      data
    })
    console.log("REQUEST CardPayment", res)
    return res;
  } catch (error) {
    return error;
  }
}
// "443102"

export {
  fetchPaymentInformation,
  requestCardPayment
}

// const ALGORITHM = 'aes-256-cbc';
// const HASH_ALGORITHM = 'sha256'
// const ENCODER = 'base64'
// const CIPHER_KEY = params.api_key;
// console.log(HASH_ALGORITHM, CIPHER_KEY)
// let SECRET_KEY = crypto.createHash(HASH_ALGORITHM).update(CIPHER_KEY).digest(ENCODER);  
// // let SECRET_KEY = btoa(crypto.createHash(HASH_ALGORITHM).update(CIPHER_KEY));
// const BLOCK_SIZE = 16;
// console.log(SECRET_KEY)
// console.log(SECRET_KEY.length)

// let hash = CryptoJS.SHA256(cardNumber);
// console.log(hash)
// let buffer = Buffer.from(hash.toString(CryptoJS.enc.Hex), 'hex');
// let array  = new Uint8Array(buffer);
// console.log(array)


// const iv = crypto.randomBytes(BLOCK_SIZE)
// console.log(iv)
// const cipher = crypto.createCipheriv(ALGORITHM, array, iv)

// const HexToString = (hexs) => {
//   let string = ''
//   hexs.forEach((hex) => {
//     string += String(parseInt(hex, 16))
//     console.log(string)
//   })

//   return string;
// }
// let hts = HexToString(iv);
// console.log(hts)

// let encrypted = cipher.update(cardNumber, 'utf8', ENCODER);
// encrypted = encrypted + cipher.final(ENCODER);
// encrypted = iv.toString('hex') + encrypted;

// console.log(encrypted)